// Scripts for My account - business account page
export default function(){
	(function($) {

		var company_loaded = false,
			is_loading_company = false;

		function is_company_loaded(status){

			var $submit_form = $("#submit_form")
			if(status){
				company_loaded = true
				$submit_form.removeClass("no-company")
				$submit_form.attr("value", "Zažádat o firemní účet")
			}else{
				company_loaded = false
				$submit_form.addClass("no-company").attr("value", "Pro zažádání vyplňte IČO")
			}
		}

		// Load company
		$('#button_search_company').on('click', function(){

			if(is_loading_company){
				return
			}

			var ico = $('#input_billing_ico').val()
			if(ico.length <= 0){
				alert("Vyplňte prosím nejdříve IČO")
				return
			}

			var $search_button = $('#button_search_company')

			$.ajax({
				type: 'POST',
				dataType: 'json',
				url: ghostpress_params.ajax_url,
				data: {
					'action': 'bnn_company_preview', //calls wp_ajax_nopriv_ajaxlogin
					'ico': ico,
				},
				beforeSend: function(){
					is_loading_company = true
					$search_button.attr('value', 'Hledám..');
				},
				success: function(response){

					var data = response.data

					if(response.success){
						is_company_loaded(true)
					}else{
						is_company_loaded(false)
					}

					var fragments = data.fragments;
					if (fragments) {
						$.each(fragments, function (key, value) {
							$(key).replaceWith(value);
						});
					}
				},
				error: function(){
					is_company_loaded(false)
				},
				complete: function(){
					is_loading_company = false
					$search_button.attr('value', 'Vyhledat firmu');
				}
			});
		});

		// Prevent to send form without company
		$('form#business-account-request').on('submit', function(e){
			if(!company_loaded){
				e.preventDefault();
				alert("Vyhledejte nejdříve svou firmu")
				return
			}
		})


	})(jQuery);
}